import {   postUpdateBank } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_UpdateBankThunk = createAsyncThunk(
  "reKyc_UpdateBankThunk",
  async ({ body, token }) => {
    try {
      const response = postUpdateBank(body, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
